
const DatetimeType = () => {
    return "";
}

export default DatetimeType;